export enum DynamicFormFieldTypeEnum {
    String,
    Integer,
    Decimal,
    Select,
    Shareholder
}
